import { getSession } from '@/utils'

export const currentProjectId = getSession('projectId')
export const currentProjectName = getSession('projectName')
export const currentProjectCode = getSession('projectCode')
export const currentProjectMainData = getSession('mainData')
export const currentProjectNodeNumber = getSession('projectNodeNumber')
export const currentProjectNodeCode = getSession('projectNodeCode')
export const currentCustomerCompany = getSession('customerCompany')
